import { useState, useEffect, useRef } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Manifesto } from "@/components/site/Manifesto";
import { OnSet } from "@/components/site/OnSet";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { RateCard } from "@/components/site/RateCard";
import { NonProfit } from "@/components/site/NonProfit";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";
import { getServices } from "@/lib/apiClient";

export default function Home() {
  const [services, setServices] = useState([]);
  const [selected, setSelected] = useState(null);
  const [nonprofitPreset, setNonprofitPreset] = useState(0);

  useEffect(() => {
    getServices().then(setServices).catch(() => {});
  }, []);

  const scrollToBooking = () => document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });

  const handleSelect = (id, np = false) => {
    setSelected(id);
    if (np) setNonprofitPreset((n) => n + 1);
    setTimeout(scrollToBooking, 120);
  };

  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero />
      <Ribbon />
      <Manifesto />
      <OnSet />
      <About />
      <Services onSelect={handleSelect} />
      <RateCard services={services} onSelect={handleSelect} />
      <NonProfit onSelect={handleSelect} />
      <Booking
        services={services}
        selected={selected}
        setSelected={setSelected}
        nonprofitPreset={nonprofitPreset}
      />
      <Footer />
    </div>
  );
}
